import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const createInvoicePDF= async () => {

    const pages = Array.from(
        document.querySelectorAll(".pageinv")
    );

    if (!pages.length) {
        throw new Error("لم يتم العثور على صفحات الفاتورة");
    }

    // انتظار الخطوط
    if (document.fonts) {
        await document.fonts.ready;
    }

    let pdf = null;

    for (let i = 0; i < pages.length; i++) {

        const element = pages[i];

        const rect = element.getBoundingClientRect();

        if (!rect.width || !rect.height) {
            continue;
        }

        // تحويل الصفحة
        const canvas = await html2canvas(element, {
            scale: 1.5,                 // مهم للسرعة والحجم
            backgroundColor: "#fff",
            useCORS: true,
            // allowTaint: false,
            logging: false,
            // imageTimeout: 3000,
            width: Math.ceil(rect.width),
            height: Math.ceil(rect.height)
        });

        // CSS pixels → mm
        const widthMM =
            rect.width * 25.4 / 96;

        const heightMM =
            rect.height * 25.4 / 96;

        if (!pdf) {

            pdf = new jsPDF({
                orientation:
                    widthMM > heightMM
                        ? "landscape"
                        : "portrait",

                unit: "mm",

                format: [
                    widthMM,
                    heightMM
                ],

                compress: true
            });

        } else {

            pdf.addPage(
                [widthMM, heightMM],
                widthMM > heightMM
                    ? "landscape"
                    : "portrait"
            );
        }

        // JPEG أصغر بكثير من PNG
        const imageData = canvas.toDataURL(
            "image/jpeg",
            0.90
        );

        pdf.addImage(
            imageData,
            "JPEG",
            0,
            0,
            widthMM,
            heightMM,
            undefined,
            "FAST"
        );

        // تحرير الذاكرة
        canvas.width = 1;
        canvas.height = 1;
    }

    if (!pdf) {
        throw new Error("فشل إنشاء PDF");
    }

    return pdf;
};

const createInvoicePDF2 = async () => {
    const pages = Array.from(
        document.querySelectorAll(".pageinv")
    );

    if (!pages.length) {
        throw new Error("لم يتم العثور على صفحات الفاتورة");
    }

    // =====================================================
    // 1) التأكد من تحميل جميع الخطوط المستخدمة في الصفحة
    // =====================================================

    if (document.fonts) {
        await document.fonts.ready;

        // انتظار إضافي حتى يعيد المتصفح رسم النصوص
        await new Promise(resolve => requestAnimationFrame(resolve));
        await new Promise(resolve => requestAnimationFrame(resolve));
    }

    // =====================================================
    // 2) إنشاء PDF
    // سيتم تحديد مقاس كل صفحة حسب تصميم React
    // =====================================================

    let pdf = null;

    for (let i = 0; i < pages.length; i++) {

        const element = pages[i];

        // ================================================
        // التأكد أن العنصر ظاهر ومكتمل
        // ================================================

        const rect = element.getBoundingClientRect();

        if (!rect.width || !rect.height) {
            continue;
        }

        // ================================================
        // إجبار المتصفح على إعادة الرسم
        // ================================================

        element.getBoundingClientRect();

        await new Promise(resolve =>
            requestAnimationFrame(resolve)
        );

        // ================================================
        // تحويل صفحة React إلى Canvas عالي الجودة
        // ================================================

        const canvas = await html2canvas(element, {

            // 4 أفضل من 3 إذا الجهاز يتحمل
            scale: 3,

            useCORS: true,

            allowTaint: false,

            backgroundColor: "#ffffff",

            logging: false,

            imageTimeout: 0,

            removeContainer: true,

            foreignObjectRendering: false,

            // الحفاظ على أبعاد الصفحة
            width: Math.ceil(rect.width),

            height: Math.ceil(rect.height),

            windowWidth: Math.max(
                document.documentElement.clientWidth,
                Math.ceil(rect.right)
            ),

            windowHeight: Math.max(
                document.documentElement.clientHeight,
                Math.ceil(rect.bottom)
            )
        });

        // ================================================
        // تحويل البكسل إلى mm
        //
        // 96 DPI = CSS pixel
        // ================================================

        const widthMM =
            (canvas.width / 4) * 25.4 / 96;

        const heightMM =
            (canvas.height / 4) * 25.4 / 96;

        // ================================================
        // أول صفحة: إنشاء PDF بمقاس الصفحة الحقيقي
        // ================================================

        if (!pdf) {

            pdf = new jsPDF({
                orientation:
                    widthMM > heightMM
                        ? "landscape"
                        : "portrait",

                unit: "mm",

                format: [
                    widthMM,
                    heightMM
                ],

                compress: true
            });

        } else {

            // ============================================
            // الصفحات التالية بنفس مقاس التصميم
            // ============================================

            pdf.addPage(
                [widthMM, heightMM],
                widthMM > heightMM
                    ? "landscape"
                    : "portrait"
            );
        }

        // ================================================
        // إضافة الصورة بدون تغيير التصميم
        // ================================================

        pdf.addImage(
            canvas.toDataURL("image/png", 1.0),
            "PNG",
            0,
            0,
            widthMM,
            heightMM,
            undefined,
            "FAST"
        );
    }

    if (!pdf) {
        throw new Error("فشل إنشاء ملف PDF");
    }

    return pdf;
};

export const downloadInvoicePdf = async (fileName) => {

    try {

        const pdf = await createInvoicePDF();

        pdf.save(fileName);

    } catch (error) {

        console.error("PDF Error:", error);

    }
};


export const shareInvoicePdf = async (fileName) => {
    const pdf = await createInvoicePDF();
    if (!pdf) return;
    let mFile = null;
    const blob = pdf.output('blob');
    mFile = new File(
        [blob],
        fileName,
        { type: blob.type }
    );
    if (navigator.share && navigator.canShare?.({ files: [mFile] })) {
        await navigator.share({
            title: "",
            text: "",
            files: [mFile]
        });

    } else {
        alert("cant share files");
    }
};





